import React from 'react'
import classNames from 'classnames'

import style from './ConsentListSectionHeader.module.scss'
import SectionTitle from './SectionTitle'

export default function ConsentListSectionHeader({
  count,
  label,
  description,
  consentType,
  indented,
  pointedBorder,
  info,
}) {
  return (
    <header
      className={classNames(
        indented ? style.indentedHeader : style.header,
        'js-consent-list-section-header legacyIndentedHeader',
        pointedBorder ? style.pointedBorder : ''
      )}
    >
      <SectionTitle
        count={count}
        label={label}
        consentType={consentType}
        info={info}
      />
      {description && (
        <div className={`${style.description} js-description`}>
          {description}
        </div>
      )}
    </header>
  )
}
